import React, { useMemo, useState } from "react";
import { IOrderItem, IOrderItemParent } from "../constants";
import TabList, { ITabItem } from "../../../yoello-lib/modules/components/UI/Tabs/TabList";
import Styles from "../../../scss/orderDetails.module.scss";
import { OrderItemDetails } from "./OrderItemDetails";
import { useTranslation } from "react-i18next";

interface IOrderItemsProps {
    inOrder: IOrderItem[],
    isPartiallyRefundedOrder: boolean,
    isRefundedOrder: boolean,
    isSquare:boolean;
    hasDiscountCode:boolean;
}

enum OrderItemDetailsTabs {
    ITEMS = "ITEMS",
    REFUNDEDITEMS = "REFUNDEDITEMS"
}
export function OrderItems({ inOrder, isPartiallyRefundedOrder , isRefundedOrder ,  isSquare , hasDiscountCode}: IOrderItemsProps) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<OrderItemDetailsTabs>(OrderItemDetailsTabs.ITEMS)
    const tabList: ITabItem[] = [
        {
            id: OrderItemDetailsTabs.ITEMS,
            label: t("PartialReafund.Items"),
            value: OrderItemDetailsTabs.ITEMS,
        },
        {
            id: OrderItemDetailsTabs.REFUNDEDITEMS,
            label: t("PartialReafund.RefundedItems"),
            value: OrderItemDetailsTabs.REFUNDEDITEMS,
        }
    ]
    /**Save orders as a hashmap of main and extras  */
    const orderItems = useMemo(() => {
        const orderItemsObject: Record<string, IOrderItemParent> = {};
        for (const item of inOrder) {
            if (!item.in_order_sold_as_extra) {
                /**add the main item as its not an extra item */
                const orderObj = orderItemsObject[item.in_order_id];
                if (orderObj) {
                    orderItemsObject[item.in_order_id] = { ...orderObj, main: item };
                } else {
                    orderItemsObject[item.in_order_id] = { main: item, extras: [] };
                }
            } else {
                /** add extra items*/
                const orderObj = orderItemsObject[item.in_order_sold_with_in_order_item_id];
                if (orderObj) {
                    orderItemsObject[item.in_order_sold_with_in_order_item_id] = { ...orderObj, extras: [...orderObj?.extras, item] }
                } else {
                    orderItemsObject[item.in_order_sold_with_in_order_item_id] = { main: {}, extras: [item] };
                }
            }
        }
        return orderItemsObject;
    }, [inOrder])
    function onChangeTab(value: any) {
        setActiveTab(value);
    }
    //TODO:fix menu name rendering 
    return <div className={Styles.OrderItemsWrapper}>
        {isPartiallyRefundedOrder && <TabList tabs={tabList} defaultTab={OrderItemDetailsTabs.ITEMS} onChange={onChangeTab} level="primary" selectedTab={activeTab} />}
        <div className={`${Styles.OrderItemsSection}`}>
        {inOrder[0].menu_name_public && <p className={Styles.MenuTitle}>{inOrder[0].menu_name_public}</p>}
            {orderItems && Object.keys(orderItems).map((key) => {
                const item = orderItems[key];
                const orderItem = { ...item.main } as IOrderItem;
                    if (activeTab === OrderItemDetailsTabs.REFUNDEDITEMS) {
                        if(orderItem.in_order_group_quantity_refunded>0){
                            return  <OrderItemDetails key={key} main={item.main as IOrderItem} extras={item.extras} isPartiallyRefundedItem={true} isSquare={isSquare} hasDiscountCode={hasDiscountCode}/>
                        }else return null
                    } else {
                        if (orderItem.in_order_group_quantity - orderItem.in_order_group_quantity_refunded > 0 || isRefundedOrder) {
                            return <OrderItemDetails key={key} main={item.main as IOrderItem} extras={item.extras}  isSquare={isSquare} hasDiscountCode={hasDiscountCode} isRefundedOrder={isRefundedOrder}/>
                        }else return null
                    }
            })}
        </div>
    </div>
}
